import { TranslationCustomerMessages, CustomerMessages } from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationCustomerMessages = {
  [CustomerMessages.applicationDashboard]: "Início",
  [CustomerMessages.applicationConcretingRequest]: "Solicitação de Programação",
  [CustomerMessages.applicationConcretingRequestAbbreviated]: "Solicitação de Prog.",
  [CustomerMessages.applicationContract]: "Contratos",
  [CustomerMessages.applicationConcreting]: "Programações",
  [CustomerMessages.applicationInvoice]: "Faturas",
  [CustomerMessages.applicationConcretingApproval]: "Aprovação de programação",
  [CustomerMessages.applicationCertificate]: "Laudos",
  [CustomerMessages.applicationClient]: "Clientes",
  [CustomerMessages.applicationPermission]: "Permissões",
  [CustomerMessages.applicationLogout]: "Sair",
  [CustomerMessages.applicationSettings]: "Configurações",
  [CustomerMessages.allUsersStatusIconTitle]: "Todos usuários",
  [CustomerMessages.newUsersStatusIconTitle]: "Novos usuários",
  [CustomerMessages.activeUsersStatusIconTitle]: "Usuários ativos",
  [CustomerMessages.inactiveUsersStatusIconTitle]: "Usuários inativados",
  [CustomerMessages.blockedUsersStatusIconTitle]: "Usuários bloqueados",
  [CustomerMessages.inactivedUser]: "Usuário inativado",
  [CustomerMessages.activedUser]: "Usuário ativado",
  [CustomerMessages.errorInactivatingUser]: "Erro ao inativar usuário",
  [CustomerMessages.errorActivatingUser]: "Erro ao ativar usuário",
  [CustomerMessages.inactivateUserTitle]: "Inativar usuário",
  [CustomerMessages.activateUserTitle]: "Ativar usuário",
  [CustomerMessages.inactivateUserText]: "Deseja inativar o usuário <USER_NAME>?",
  [CustomerMessages.activateUserText]: "Deseja ativar o usuário <USER_NAME>?",
  [CustomerMessages.activateUserButton]: "Ativar",
  [CustomerMessages.inactivateUserButton]: "Inativar"
};
